import styled from 'styled-components';
import { textblocks } from 'seal-ui-components';
import { getBaseTheme } from '@Themes';

const { spaces } = getBaseTheme();

export const PopupInner = styled.div({
    display: 'flex',
    flexDirection: 'column',
    padding: `${spaces.default.s} 0`
});

export const ButtonsContainer = styled.div({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',

    'button:focus': {
        outline: 'none'
    }
});

export const Title = styled(textblocks.Heading4)({
    textTransform: 'uppercase',
    margin: spaces.default.s
});

export const BodyText = styled.div({
    margin: `${spaces.default.xs} 0`
});
